import React, { Component } from 'react';
import './CreateConfig.scss';
import history from '../../Routers/history';

import Button from '../../Elements/Atoms/Button';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getBotInfo, getGenericData, getSelectedBotData, updateBotValue, updateBotValueConfig } from '../../Redux/Actions/uiActions';

// import tempEnBotData from '../../../assets/BotForge_Config7.json';
import { Link } from 'react-router-dom';
import Elements from '../../Elements';
import down_arrow from '../../../assets/icons/ic_expand_blue.png';
import { ButtonV3 } from 'react-ui-lib';

class CreateConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeInputtab: 'upload-tab',
            fileUploaded: false,
            inputKey: new Date().getTime(),
            selectedFileName: '',
            inputData: '',
            langSelector: false,
            language: [
                { name: 'Arabic', code: 'ar' },
                { name: 'Cantonese', code: 'zh-yue' },
                { name: 'Dutch', code: 'nl' },
                { name: 'English', code: 'en' },
                { name: 'French', code: 'fr' },
                { name: 'German', code: 'de' },
                { name: 'Italian', code: 'it' },
                { name: 'Malay', code: 'ms' },
                { name: 'Mandarin', code: 'zh-cmn' },
                { name: 'Polish', code: 'pl' },
                { name: 'Portuguese', code: 'pt' },
                { name: 'Spanish', code: 'es' },
                { name: 'Swedish', code: 'sv' }
            ],
            slectedLangElm: { name: 'English', code: 'en' },
        }
        this.botIdRef = React.createRef();
        this.serverIpRef = React.createRef();
        this.portRef = React.createRef();
        this.langConatiner = React.createRef();
        this.langnode = React.createRef();
    }

    addSelectEnvValue = () => {
        return (
            <span className = 'eb-icon-btn-image'>
                <Elements.Atoms.ImgTag
                    className = 'image'
                    src = {down_arrow}
                    alt = 'Close'
                />
            </span>
        );
    }

    UNSAFE_componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if(this.langnode && this.langnode.contains(e.target)) {
            const selectedLangCode = e.target.getAttribute('value');
            const selectedLang = e.target.getAttribute('name');
            this.setState({slectedLangElm: {name: selectedLang, code: selectedLangCode}, langSelector: false});
            return;
        }
        if(this.langConatiner && this.langConatiner.contains(e.target)) {
            return;
        }

        this.setState({langSelector: false});
    }

    render() {
        let homeBtnUrl = `/${this.props.selectedBotID}`;
        let baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'https://sit-aida-live-chat.enterprisebot.co';
        if(!this.props.selectedBotID) {
            homeBtnUrl = '/';
        }

        const langMenuClass = 'nav-item language-select-create' + (this.state.langSelector ? ' open' : '')
        return (
            <div className = 'create-config-tab create-config'>
                <div className = 'body-section right-section'>
                    <h3 className = 'tab-header'>Create a new config</h3>
                    <div className = 'config-input-wrapper'>
                        <div className = "config-input-block field-size-md">
                            <div className = "config-label">
                                <label className = "config-title">Bot ID</label>
                            </div>
                            <div className = "config-input-area">
                                <div className = "character-input-box field-size-md">
                                    <input className = "form-control character-input" type="text" placeholder="Enter here..." autoComplete="off" defaultValue="" ref = {this.botIdRef}/>
                                </div>
                            </div>
                        </div>
                        <div className = "config-input-block field-size-md">
                            <div className = "config-label">
                                <label className = "config-title">Server IP</label>
                            </div>
                            <div className = "config-input-area">
                                <div className = "character-input-box field-size-md">
                                    <input className = "form-control character-input" type="text" placeholder="Enter here..." autoComplete="off" defaultValue={baseUrl} ref = {this.serverIpRef}/>
                                </div>
                            </div>
                        </div>
                        <div className = "config-input-block field-size-md">
                            <div className = "config-label">
                                <label className = "config-title">Port Number</label>
                            </div>
                            <div className = "config-input-area">
                                <div className = "character-input-box field-size-md">
                                    <input className = "form-control character-input" type="number" placeholder="Enter here..." autoComplete="off" defaultValue={3005} ref = {this.portRef}/>
                                </div>
                            </div>
                        </div>
                        <div className = "config-input-block field-size-md">
                            <div className = "config-label">
                                <label className = "config-title">Language</label>
                            </div>
                            <div className = "config-input-area">
                                <div className = "character-input-box field-size-md">
                                    <div className={langMenuClass} key={11} ref = {langConatiner => this.langConatiner = langConatiner} onClick = {() => {
                                        this.setState({langSelector: !this.state.langSelector});
                                    }}>
                                        <div className = 'selector-btn' id = 'botForgeEnvironment' datatoggle = 'dropdown'>
                                            <span className = 'selector-name'>{this.state.slectedLangElm.name}</span>
                                            <div className = 'icon-button-wrapper go-float-right'>
                                                <Elements.Atoms.Button
                                                    title ='Options'
                                                    className = 'eb-icon-btn-style'
                                                    type = 'button'
                                                    value = {this.addSelectEnvValue()}
                                                />
                                            </div>
                                        </div>
                                        <div className = 'dropdown-menu' aria-labelledby = 'botForgeBotId' ref = {langnode => this.langnode = langnode}>
                                            {
                                                this.state.language.map((elem, i) => {
                                                    if(JSON.stringify(elem) !== JSON.stringify(this.state.slectedLangElm)) {
                                                        return (
                                                            <span className = 'dropdown-item' value = {elem.code} title = {elem.name} name = {elem.name} key = {i} >{elem.name}</span>
                                                        );
                                                    } else {
                                                        return null;
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className = 'config-input-tabs-buttons' style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <ButtonV3 
                            key = 'Reset'
                            name = 'Reset'
                            title = 'Reset to default'
                            btnstyle = {{marginRight: '1rem'}}
                            btnStyleType='secondary2'
                            onClick={(e) => {
                                if(this.botIdRef && this.botIdRef.current && this.botIdRef.current.value) {
                                    this.botIdRef.current.value = '';
                                }
                                if(this.serverIpRef && this.serverIpRef.current && this.serverIpRef.current.value) {
                                    this.serverIpRef.current.value = baseUrl;
                                }
                                if(this.portRef && this.portRef.current && this.portRef.current.value) {
                                    this.portRef.current.value = 3005;
                                }
                                this.setState({slectedLangElm: {name: 'English', code: 'en'}, langSelector: false});
                                // this.setState({fileUploaded: false, inputKey: new Date().getTime(), selectedFileName: '', inputData: ''});
                            }}
                        />
                        <ButtonV3 
                            key = 'Create'
                            name = 'Create'
                            title = 'Create custom config'
                            btnstyle = {{}}
                            onClick={(e) => {
                                if(this.botIdRef.current && this.serverIpRef.current && this.portRef.current) {
                                    let inputBotId = this.botIdRef.current.value;
                                    let inputServerIp = this.serverIpRef.current.value;
                                    let inputPortNum = this.portRef.current.value;
                                    let inputLang = this.state.slectedLangElm.code;
                                    let errMsg = '';

                                    if(!inputBotId.length) {
                                        errMsg = "botID can't be empty";
                                    } else if(!inputServerIp.length) {
                                        errMsg = "Serve IP can't be empty";
                                    } else if(!inputPortNum.length) {
                                        errMsg = "Port Number can't be empty";
                                    } else if(!inputLang.length) {
                                        errMsg = "Language can't be empty";
                                    }

                                    if(errMsg !== '') {
                                        alert(errMsg + ', Please verify and retry');
                                        return;
                                    } else {
                                        let currentElem = this.props.availableBotList.filter(elm => {
                                            return elm.id === inputBotId;
                                        });
                                        if(!currentElem.length) {
                                            alert("The bot data provide here doesn't belongs to this team or incorrect, Please verify and retry");
                                            return;
                                        } else {
                                            this.props.getSelectedBotData(inputBotId, (res) => {
                                                // this.props.getBotInfo(inputBotId);
                                                if(!res?.['bot-config']?.CUSTOM_BOT_UI?.VALUE) {
                                                    const configLang = inputLang || currentElem?.[0]?.langISO;
                                                    this.props.getGenericData(configLang, (res) => {
                                                        // let tempdata = tempEnBotData;
                                                        let tempdata = res;
                                                        tempdata.botId = inputBotId;
                                                        let tempBotElmData = {
                                                            "ELEM_TYPE": "text-field",
                                                            "ELEM_DESC": "BotID for ui",
                                                            "VALUE": inputBotId
                                                        }
                                                        tempdata.SETTINGS.BOTID = tempBotElmData;
                                                        tempdata.SETTINGS.SERVER_IP_PORT.VALUE = inputServerIp;
                                                        tempdata.POST_OPTIONS.port = inputPortNum;
                                                        tempdata.CUSTOM_BOT_UI.VALUE = true;
                                                        let newData = {};
                                                        newData['bot-config'] = tempdata;
                                                        newData['kbId'] = this.props.kbId;
                                                        history.push(`/${inputBotId}/chatbot`);
                                                        this.props.updateBotValueConfig(newData, inputBotId);
                                                    }, (err) => {
                                                        console.log('err', err);
                                                        this.setState({blockGenericUi: false})
                                                    })
                                                } else {
                                                    this.props.updateBotValueConfig(res, inputBotId)
                                                    history.push(`/${inputBotId}/chatbot`);
                                                }
                                            }, null, true)                                            
                                        }
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
                

                <div className = 'create-config-devider'>
                    OR
                </div>
                
                <div className = 'config-input-tabs-buttons bottom-navigation-button'>
                    <Link to = {homeBtnUrl}>
                        <ButtonV3
                            className = ''
                            btnStyleType='secondary2'
                            btnstyle = {{marginRight: '1rem'}}
                            name = 'Home'
                            title = 'Home'
                        />
                    </Link>
                    <Link to = '/importconfig'>
                        <ButtonV3
                            className = ''
                            name = 'Import JSON'
                            title = 'Import JSON'
                        />
                    </Link>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        kbId: state.UiReducer && state.UiReducer.kbId ? state.UiReducer.kbId : undefined
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getGenericData,
        updateBotValue,
        updateBotValueConfig,
        getSelectedBotData,
        getBotInfo
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CreateConfig));
